import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://nrxokxrqacklgzynwhdk.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5yeG9reHJxYWNrbGd6eW53aGRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODkxNjI0ODUsImV4cCI6MjAwNDczODQ4NX0.CHvdm8zCkvbwTKTGLUxZczcG53_rkB7-ZWWhdXFjEVQ";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
